import { ModuleMapFeature } from 'features/Mappers/Module';

export const SharedContentModuleFeature: React.FC<Umbraco.SharedContentModule> = ({ content }) => {
	const { modules } = content?.properties?.content?.properties ?? {};
	return <>{modules && modules.map((module, index) => <ModuleMapFeature contentModule={module} key={index} />)}</>;
};
